// Example useCountdown hook with restart functionality
import { useEffect, useRef, useState } from 'react';
 
const useCountdown = (seconds: number) => {
  const [timeLeft, setTimeLeft] = useState(seconds);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
 
  const startTimer = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    setTimeLeft(seconds);
    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev === 1) {
          clearInterval(intervalRef.current!);
        }
        return prev - 1;
      });
    }, 1000);
  };
 
  useEffect(() => {
    startTimer();
    return () => clearInterval(intervalRef.current!);
  }, []);
 
  return {
    timeLeft,
    restart: startTimer,
  };
};
 
export default useCountdown;